// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Champ de date jj/mm/aaaa (ChampDate.js) — prend le style de l'input qu'il remplace */
.champ-date {
    position: relative;
    display: block;
    min-width: 9.5em;
}
.champ-date > input[type="text"] {
    width: 100%;
    box-sizing: border-box;
    padding-right: 28px;
}
.champ-date > input.champ-date-invalide {
    border-color: #dc2626;
    box-shadow: 0 0 0 1px #dc2626;
}
.champ-date-bouton {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    border: none;
    background: none;
    padding: 2px 4px;
    color: #64748b;
    cursor: pointer;
    line-height: 1;
}
.champ-date-bouton:hover:not(:disabled) { color: #1e293b; }
.champ-date-bouton:disabled { cursor: not-allowed; opacity: .5; }
/* Le sélecteur natif sert seulement à ouvrir le calendrier sous le champ : jamais visible */
.champ-date-selecteur {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 1px;
    height: 1px;
    padding: 0;
    border: 0;
    opacity: 0;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampDate.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA,0CAA0C,cAAc,EAAE;AAC1D,8BAA8B,mBAAmB,EAAE,WAAW,EAAE;AAChE,4FAA4F;AAC5F;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,SAAS;IACT,UAAU;IACV,oBAAoB;AACxB","sourcesContent":["/* Champ de date jj/mm/aaaa (ChampDate.js) — prend le style de l'input qu'il remplace */\n.champ-date {\n    position: relative;\n    display: block;\n    min-width: 9.5em;\n}\n.champ-date > input[type=\"text\"] {\n    width: 100%;\n    box-sizing: border-box;\n    padding-right: 28px;\n}\n.champ-date > input.champ-date-invalide {\n    border-color: #dc2626;\n    box-shadow: 0 0 0 1px #dc2626;\n}\n.champ-date-bouton {\n    position: absolute;\n    top: 50%;\n    right: 4px;\n    transform: translateY(-50%);\n    border: none;\n    background: none;\n    padding: 2px 4px;\n    color: #64748b;\n    cursor: pointer;\n    line-height: 1;\n}\n.champ-date-bouton:hover:not(:disabled) { color: #1e293b; }\n.champ-date-bouton:disabled { cursor: not-allowed; opacity: .5; }\n/* Le sélecteur natif sert seulement à ouvrir le calendrier sous le champ : jamais visible */\n.champ-date-selecteur {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    border: 0;\n    opacity: 0;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
